<template>
    <div class="box" @mouseover="handleBoxOver" @mouseout="handleBoxOut">
        <transition-group tag="ul" name="fade"
        
        >
            <li v-for="pic in pics" :key="pic.src" :class="{current:pic.isActive}" data-index="pic.count">
                <img :src="pic.src" v-if="pic.isActive" width="490" height="170">
            </li>
        </transition-group>
        <ul class="count">
            <li v-for="item in pics" :key="item.count" :class="{current:item.isActive}"
            @mouseover="handleCountOver(item.count)"
            >
                {{item.count+1}}
            </li>
        </ul>
    </div>
</template>
<script>
import { setInterval, clearInterval } from 'timers';
export default {
    name:'Navs',
    data(){
        return{
            index:0,
            timer:null,
            play:null,
        pics:[
            {
                src:require('./assets/lesson4/01.jpg'),
                isActive:true,
                count:0
            },
            {
                src:require('./assets/lesson4/02.jpg'),
                isActive:false,
                count:1
            },
            {
                src:require('./assets/lesson4/03.jpg'),
                isActive:false,
                count:2
            },
            {
                src:require('./assets/lesson4/04.jpg'),
                isActive:false,
                count:3
            },
            {
                src:require('./assets/lesson4/05.jpg'),
                isActive:false,
                count:4
            },

        ]
        }
    },
    methods:{
        handleBoxOver(){
            clearInterval(this.play);
        },
        handleBoxOut(){
            this.auotPlay()
        },
        auotPlay(){
            var _this=this;
            this.play=setInterval(function(){
                _this.index++;
                _this.index >= _this.pics.length && (_this.index=0);
                _this.show(_this.index)
            },2000)
        },
        show(count){
            
            this.index=count;
            for(var i=0;i<this.pics.length;i++) this.pics[i].isActive=false;
            this.pics[this.index].isActive=true;
        },
        handleCountOver(count){
            this.show(count)
        },
        enter(el,done){
            
        },
        leave(el,done){
            
        }
    },
    created(){
        this.auotPlay();
    }
}
</script>
<style>
.fade-enter-active, .fade-leave-active{
    transition: all 0.3s ease;
}
.fade-enter, .fade-leave-to{
    opacity: 0;
}
body, div, ul, li{
    margin: 0;
    padding: 0;
}
ul{
    list-style-type: none;
}
body{
    background: #000;
    text-align: center;
    font: 12px/20px arial;
}
.box{
    position: relative;
    width: 492px;
    height: 172px;
    background: #fff;
    border-radius: 5px;
    border: 8px solid #fff;
    margin: 10px auto;
}
.box .list{
    position: relative;
    width: 490px;
    height: 170px;
    overflow: hidden;
    border: 1px solid #ccc;
}
.box .list li{
    position: absolute;
    top:0;
    left: 0;
    width: 490px;
    height: 170px;
    opacity: 0;
    filter: alpha(opacity=0);
}
.box .list li.current{
    transition: opacity .3s ease;
    opacity: 1;
    filter: alpha(opacity=100);
}
.box .count{
    position: absolute;
    right: 0;
    bottom: 5px;
}
.box .count li{
    color: #fff;
    float: left;
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-right: 5px;
    overflow: hidden;
    background: #f90;
    opacity: 0.7;
    filter: alpha(opacity=70);
    border-radius: 20px;
}
.box .count li.current{
    color: #fff;
    opacity: 1;
    filter: alpha(opacity=100);
    font-weight: 700;
    background: #f60;
}
</style>
